import type { ApprovalChain } from '../approval-chain.model';

export const DEED_RE_ISSUANCE_CHAIN: ApprovalChain = {
  id: 'deed-re-issuance',
  label: 'Issuance of a Securitized Title Deed',
  applicationTypes: ['DEED_RE_ISSUANCE'],
  steps: [
    { role: 'FINANCE_OFFICER', action: 'Approve Payment', from: ['SUBMITTED', 'RESUBMITTED'], to: 'FINANCE_APPROVED' },
    { role: 'REGISTRY', action: 'Recommend', from: ['FINANCE_APPROVED'], to: 'REGISTRY_RECOMMENDED' },
    { role: 'EXAMINER', action: 'Recommend', from: ['FINANCE_APPROVED', 'REGISTRY_RECOMMENDED'], to: 'EXAMINER_RECOMMENDED' },
    { role: 'REGISTRAR', action: 'Verify', from: ['EXAMINER_RECOMMENDED'], to: 'REGISTRAR_VERIFIED' },
  ],
};
